(() => {
  const root = document.querySelector('.ipp-studio');
  if (!root) return;
  const quantity = root.querySelector('#IvoryQuantity');
  const action = root.querySelector('[data-product-quote]');
  const sticky = root.querySelector('[data-ipp-sticky]');
  const stickyAdd = root.querySelector('[data-ipp-sticky-add]');
  const clamp = (n) => Math.min(9999, Math.max(1, Math.floor(Number(n) || 1)));
  const sync = () => {
    quantity.value = clamp(quantity.value);
    root.querySelector('[data-ivory-app-variant]').value = action.dataset.id;
    root.querySelector('[data-ipp-sticky-quantity]').textContent = quantity.value;
    root.querySelector('[data-ipp-sticky-option]').textContent = action.dataset.color === 'Default Title' ? '' : action.dataset.color;
    stickyAdd.disabled = action.disabled;
    root.querySelector('[data-ipp-variant-status]').textContent = action.disabled ? root.dataset.unavailable : '';
  };
  root.querySelectorAll('[data-ipp-step]').forEach((button) => button.addEventListener('click', () => {
    quantity.value = clamp(Number(quantity.value) + Number(button.dataset.ippStep));
    quantity.dispatchEvent(new Event('change', { bubbles: true }));
  }));
  quantity.addEventListener('change', sync);
  quantity.addEventListener('input', () => { root.querySelector('[data-ipp-sticky-quantity]').textContent = clamp(quantity.value); });
  action.addEventListener('click', () => { quantity.value = clamp(quantity.value); });
  stickyAdd.addEventListener('click', () => { sync(); action.click(); });
  root.querySelectorAll('[data-option-value]').forEach((button) => button.addEventListener('click', () => queueMicrotask(sync)));
  sync();
  const dialog = root.querySelector('[data-ipp-lightbox]');
  const large = root.querySelector('[data-ipp-large]');
  root.querySelector('[data-ipp-zoom]')?.addEventListener('click', () => {
    const photo = root.querySelector('#IvoryMainImage');
    large.src = photo.currentSrc || photo.src;
    large.alt = photo.alt;
    dialog.showModal();
  });
  dialog.addEventListener('click', (event) => { if (event.target === dialog) dialog.close(); });
  const tabs = [...root.querySelectorAll('[data-ipp-tab]')];
  const activateTab = (tab, focus = false) => {
    tabs.forEach((item) => {
      const selected = item === tab;
      item.setAttribute('aria-selected', String(selected));
      item.tabIndex = selected ? 0 : -1;
      root.querySelector('#' + item.getAttribute('aria-controls')).hidden = !selected;
    });
    if (focus) tab.focus();
  };
  tabs.forEach((tab, index) => {
    tab.addEventListener('click', () => activateTab(tab));
    tab.addEventListener('keydown', (event) => {
      let next;
      if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
      if (event.key === 'ArrowLeft') next = (index + tabs.length - 1) % tabs.length;
      if (event.key === 'Home') next = 0;
      if (event.key === 'End') next = tabs.length - 1;
      if (next !== undefined) { event.preventDefault(); activateTab(tabs[next], true); }
    });
  });
  root.querySelectorAll('[data-photo]').forEach((button) => button.addEventListener('click', () => {
    button.scrollIntoView({ block: 'nearest', inline: 'nearest' });
  }));
  if ('IntersectionObserver' in window) {
    let buttonVisible = true;
    let footerVisible = false;
    const updateSticky = () => { sticky.hidden = buttonVisible || footerVisible; };
    const buttonObserver = new IntersectionObserver(([entry]) => {
      buttonVisible = entry.isIntersecting || entry.boundingClientRect.top > 0;
      updateSticky();
    });
    buttonObserver.observe(action);
    const footer = document.querySelector('[data-footer-shell]') || document.querySelector('footer');
    if (footer) new IntersectionObserver(([entry]) => { footerVisible = entry.isIntersecting; updateSticky(); }).observe(footer);
  }
  const cutouts = new Map();
  const plainWhiteCutout = (url) => {
    if (cutouts.has(url)) return cutouts.get(url);
    const promise = new Promise((resolve) => {
      const source = new Image();
      source.crossOrigin = 'anonymous';
      source.onload = () => {
        try {
          const ratio = Math.min(1, 1600 / Math.max(source.naturalWidth, source.naturalHeight));
          const width = Math.round(source.naturalWidth * ratio);
          const height = Math.round(source.naturalHeight * ratio);
          const canvas = document.createElement('canvas');
          canvas.width = width;
          canvas.height = height;
          const context = canvas.getContext('2d', { willReadFrequently: true });
          context.drawImage(source, 0, 0, width, height);
          const frame = context.getImageData(0, 0, width, height);
          const pixels = frame.data;
          const total = width * height;
          const white = (index) => {
            const offset = index * 4;
            const low = Math.min(pixels[offset], pixels[offset + 1], pixels[offset + 2]);
            const high = Math.max(pixels[offset], pixels[offset + 1], pixels[offset + 2]);
            return low >= 245 && high - low <= 8;
          };
          let borderSamples = 0;
          let borderWhite = 0;
          for (let x = 0; x < width; x += 8) { borderSamples += 2; borderWhite += Number(white(x)) + Number(white((height - 1) * width + x)); }
          for (let y = 0; y < height; y += 8) { borderSamples += 2; borderWhite += Number(white(y * width)) + Number(white(y * width + width - 1)); }
          if (borderWhite / borderSamples < .92) { resolve(null); return; }
          const visited = new Uint8Array(total);
          const queue = new Int32Array(total);
          let tail = 0;
          const add = (index) => { if (!visited[index] && white(index)) { visited[index] = 1; queue[tail++] = index; } };
          for (let x = 0; x < width; x++) { add(x); add((height - 1) * width + x); }
          for (let y = 0; y < height; y++) { add(y * width); add(y * width + width - 1); }
          for (let head = 0; head < tail; head++) {
            const index = queue[head];
            const x = index % width;
            if (x > 0) add(index - 1);
            if (x < width - 1) add(index + 1);
            if (index >= width) add(index - width);
            if (index < total - width) add(index + width);
          }
          if (tail < total * .1 || tail > total * .98) { resolve(null); return; }
          for (let i = 0; i < tail; i++) {
            const offset = queue[i] * 4;
            const low = Math.min(pixels[offset], pixels[offset + 1], pixels[offset + 2]);
            pixels[offset + 3] = low >= 251 ? 0 : Math.round((251 - low) / 6 * 80);
          }
          context.putImageData(frame, 0, 0);
          canvas.toBlob((blob) => resolve(blob ? URL.createObjectURL(blob) : null), 'image/png');
        } catch { resolve(null); }
      };
      source.onerror = () => resolve(null);
      source.src = url;
    });
    cutouts.set(url, promise);
    return promise;
  };
  const processPhoto = async (photo) => {
    const url = photo.currentSrc || photo.src;
    if (!url || url.startsWith('blob:') || photo.dataset.cutoutSource === url) return;
    photo.dataset.cutoutSource = url;
    const result = await plainWhiteCutout(url);
    if (photo.dataset.cutoutSource !== url) return;
    if (!result) { photo.dataset.cutout = 'original'; return; }
    if ((photo.currentSrc || photo.src) !== url) return;
    photo.removeAttribute('srcset');
    photo.removeAttribute('sizes');
    photo.src = result;
    photo.dataset.cutout = 'done';
  };
  const photos = root.querySelectorAll('.ipp-product-photo');
  const photoObserver = 'IntersectionObserver' in window ? new IntersectionObserver((entries) => {
    entries.forEach((entry) => { if (entry.isIntersecting) { processPhoto(entry.target); photoObserver.unobserve(entry.target); } });
  }, { rootMargin: '250px' }) : null;
  photos.forEach((photo) => {
    photo.addEventListener('load', () => {
      if (photo.dataset.cutout !== 'done' || !photo.src.startsWith('blob:')) {
        const rect = photo.getBoundingClientRect();
        if (rect.top < innerHeight + 250 && rect.bottom > -250) processPhoto(photo);
      }
    });
    if (photoObserver) photoObserver.observe(photo); else processPhoto(photo);
  });
})();
